import {useTranslation} from 'react-i18next';

export const useRequirementsTranslation = () => {
	return useTranslation('components/columnrenderers', {
		keyPrefix: 'Requirements',
	});
};
